var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "8px",
    viewBox: "0 0 16 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-1844.000000, -40.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1844.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,1.6 L16,1.6 L16,0 L0,0 Z M0,6.4 L0,8 L16,8 L16,6.4 L0,6.4 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.d0ac187ca98341a0ce5dd5e9633c2a99.svg";
export { ForwardRef as ReactComponent };